import {
    PaginatedResponse,
    PressReleaseEntity,
    PressReleaseLight,
    PressReleaseListFilter,
} from '@finance-lab/utils/types'
import ApiBase from './Api'

export class PressReleaseApi extends ApiBase {
    allPressReleases(
        paginationModel: {
            page: number
            pageSize: number
        },
        filter: PressReleaseListFilter,
    ): Promise<PaginatedResponse<PressReleaseLight>> {
        const queryParams = Object.keys(filter)
            .filter((f) => !!filter[f as keyof PressReleaseListFilter])
            .map((f) => `${f}=${filter[f as keyof PressReleaseListFilter]}`)
            .join('&')
        return this._getRequest(
            `/press-releases?page=${paginationModel.page}&limit=${paginationModel.pageSize}&${queryParams}`,
        )
    }

    findById(id: string): Promise<PressReleaseEntity> {
        return this._getRequest(`/press-releases/${id}`)
    }

    findByCompanyId(companyId: string): Promise<PressReleaseLight[]> {
        return this._getRequest(`/press-releases?companyId=${companyId}`)
    }
}
